import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

/* ── localisation ─────────────────────────────────────── */
import "./i18n";                       // bootstraps i18next
import i18n from "./i18n";
import { I18nextProvider } from "react-i18next";

/* ── <Helmet> support for SEO tags ────────────────────── */
import { HelmetProvider } from "react-helmet-async";

/* update <html lang="…"> whenever the user toggles */
i18n.on("languageChanged", (lng) => {
  document.documentElement.lang = lng;
});
/* …and on first load (path/localStorage detection fires no change event) */
document.documentElement.lang = i18n.language;

/* ── mount ────────────────────────────────────────────── */
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <HelmetProvider>
    <React.StrictMode>
      <I18nextProvider i18n={i18n}>
        <App />
      </I18nextProvider>
    </React.StrictMode>
  </HelmetProvider>
);

/* optional performance reporting */
reportWebVitals();

